/**
 * React Query hook for invitation counts (friend + group received pending).
 * Used by tab badge and useReceivedInvitesCount so full friends/groups lists are not fetched for counts.
 */

import { useQuery } from '@tanstack/react-query';
import { useSupabaseAuth } from '../../shared/contexts/SupabaseAuthContext';
import { useApiClient } from '../../../helpers/apiClient.helper';
import { fetchInvitationCounts } from '../helpers/invitationsApi';

const STALE_TIME_MS = 2 * 60 * 1000; // 2 minutes
const GC_TIME_MS = 10 * 60 * 1000;   // 10 minutes

export function useInvitationCountsQuery() {
  const apiClient = useApiClient();
  const { userId, isLoaded, isSignedIn } = useSupabaseAuth();
  const enabled = isSignedIn === true && isLoaded === true && !!userId;

  return useQuery({
    queryKey: ['invitationCounts', userId ?? ''],
    queryFn: () => fetchInvitationCounts(apiClient),
    enabled,
    staleTime: STALE_TIME_MS,
    gcTime: GC_TIME_MS,
  });
}
